import React from "react";

import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()({
  visible: {
    visibility: "visible",
  },
  hidden: {
    visibility: "hidden",
  },
  collapse: {
    display: "none",
  },
});

interface Props {
  visible: boolean;
  shouldCollapse?: boolean;
}

const Visibility: React.FC<Props> = ({
  visible,
  shouldCollapse = false,
  children,
}) => {
  const { classes, cx } = useStyles();
  const hideClass = shouldCollapse ? classes.collapse : classes.hidden;
  return (
    <div
      className={cx({
        [classes.visible]: visible,
        [hideClass]: !visible,
      })}
    >
      {children}
    </div>
  );
};

export default Visibility;
